import HomePageAbout from './HomePageAbout';

export default HomePageAbout;
